import PropTypes from 'prop-types';
import H3 from '@base/H3/H3';
import H6 from '@base/H6/H6';
import H7 from '@base/H7/H7';
import P1 from '@base/P1/P1';
import { Spacings } from '@styles/index';
import styled from '@emotion/styled';
import Image from '@base/Image';
import { groupPerks } from '../groupsConstants';

const Wrapper = styled.div`
  grid-column: 1/10;
  padding-bottom: ${Spacings.SPACING_6B};
`;

const StyH3 = styled(H3)`
  margin-top: ${Spacings.SPACING_6B};
`;

const StyP1 = styled(P1)`
  color: var(--color-text-secondary);
  margin-top: ${Spacings.SPACING_2B};
`;

const PerksWrapper = styled.div`
  margin-top: ${Spacings.SPACING_8B};
  margin-bottom: ${Spacings.SPACING_8B};
`;

const Perk = styled.div`
  margin-top: ${Spacings.SPACING_4B};
  display: flex;
  align-items: center;
`;

const StyH6 = styled(H6)`
  margin-left: ${Spacings.SPACING_3B};
`;

const JoinGroupWrapper = styled.div`
  display: inline-flex;
  cursor: pointer;
  padding-bottom: 7px;
  border-bottom: ${Spacings.SPACING_1} dashed var(--color-base-fill);
`;

const GroupJoinCard = ({ redirectToPlayStore }) => {
  return (
    <Wrapper>
      <Image
        src="groups/onboarding.png"
        height={235}
        width={416}
        alt="unacademy"
      />
      <StyH3>Learn with a group</StyH3>
      <StyP1>
        Group is the all-new way to learn with your friends and compete with
        them in weekly competitions.
      </StyP1>
      <PerksWrapper>
        {groupPerks.map((perk) => (
          <Perk key={perk.label}>
            <Image src={perk.icon} height={24} width={24} alt="unacademy" />
            <StyH6>{perk.label}</StyH6>
          </Perk>
        ))}
      </PerksWrapper>
      <JoinGroupWrapper onClick={redirectToPlayStore}>
        <H7>Join from App</H7>
      </JoinGroupWrapper>
    </Wrapper>
  );
};

export default GroupJoinCard;

GroupJoinCard.propTypes = {
  redirectToPlayStore: PropTypes.func.isRequired
};
